import Vue from 'vue'
import App from './App.vue'
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueRouter from 'vue-router';
import {routes} from './routes.js';

Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(VueRouter);

const router = new VueRouter({
    routes: routes,
    mode: 'history',
    base: '/'
});

new Vue({
    render: h => h(App),
    router: router
}).$mount('#app');
